<template>
  <div class="ig" v-if="dashdata" v-bind:class="getBackground()">
    <country-header class="hd"
                    :text="getHeader()" />

    <kpi-header class="sh"
                :history="history"
                :waves="waves"
                :kpi="clusterOverall" />

    <div  v-if="!hasData" class="placeholder">
      <span>{{ $t('Webportal.NoData') }}</span>
    </div>

    <kpi-item v-if="hasData"
              class="pe"
              :history="history"
              :waves="waves"
              :overall="clusterOverall"
              :kpi="clusterProcessExcellence"
              :thresholds="thresholds" />

    <kpi-item v-if="hasData" :kpi="kpiLeadFollowUp"
              class="lfu"
              :overall="clusterOverall"
              :history="history"
              :waves="waves"
              :thresholds="leadFuThresholds"
              :hasIcons="true" />

    <kpi-item v-if="hasData"
              class="afu"
              :history="history"
              :waves="waves"
              :kpi="kpiAppointmentFollowUp"
              :thresholds="thresholds" />

    <kpi-item v-if="hasData"
              class="lm1"
              :history="history"
              :waves="waves"
              :kpi="clusterLMTD"
              :thresholds="lmThresholds" />
    
    <kpi-item v-if="hasData"
              class="lm2"
              :history="history"
              :waves="waves"
              :kpi="clusterLMIO"
              :thresholds="lmThresholds" />

    <kpi-item v-if="hasData"
              class="lm3"
              :history="history"
              :waves="waves"
              :kpi="clusterXevReadyness"
              :thresholds="lmThresholds" />
    
    <kpi-item v-if="hasData"
              class="lm4"
              :history="history"
              :waves="waves"
              :kpi="kpiBmwApp"
              :thresholds="lmThresholds" />

    <kpi-item v-if="hasData"
              class="ct bbtm"
              :history="history"
              :waves="waves"
              :kpi="clusterCustomerTreatment"
              colorMode="mono"
              :editHeight="true"
              :thresholds="thresholds" />
  </div>
</template>

<script>
import CompareCountryHeader from './CompareCountryHeader';
import CompareKpiHeader from './CompareKpiHeader';
import CompareKpiItem from './CompareKpiItem';
import JoinKpiWavesMixin from '@/mixins/bmw/JoinKpiWavesMixin';

export default {
  components: {
    'country-header': CompareCountryHeader,
    'kpi-header': CompareKpiHeader,
    'kpi-item': CompareKpiItem
  },
  mixins: [JoinKpiWavesMixin],
  props: {
    dashdata: { type: Object, default: undefined },
    history: { type: Array },
    thresholds: { type: Array, required: true },
    lmThresholds: { type: Array, required: true },
    leadFuThresholds: { type: Array, required: false, default: undefined },
    waves: { type: Array, required: true }
  },
  methods: {
    getHeader() {
      // Display ClientLocationIdOnClientSite instead of ClientLocationId
      if(this.dashdata.filterStage.mode.name === "outlets") {
        let header = this.dashdata.outletData.label;
        header = header.split(' ')[0];
        return header
      }
      return _.last(_.split(this.dashdata.filterStage.text, '^', 2)).split('§')[0];
    },
    getKpi(kpiCode) {
      let kpi = _.find(this.dashdata.KPI, ['KpiCode', kpiCode]);
      return kpi || null;
    },
    getCluster(kpiCode) {
      let kpi = _.find(this.dashdata.KPIGroup, ['KpiCode', kpiCode]);
      return kpi || null;
    },
    getBackground() {
      if (!this.hasData) {
        return 'bgfaded';
      }
    }
  },
  computed: {
    hasData() {
      return this.dashdata && this.dashdata.KPI;
    },
    clusterProcessExcellence() {
      return this.getCluster('Process Excellence');
    },
    clusterCustomerTreatment() {
      return this.joinKpi(
        this.getCluster('Customer Treatment'),
        this.getKpi('Recommendation'));
    },
    clusterOverall() {
      return this.dashdata.OverallByWave[0];
    },
    kpiAppointmentFollowUp() {
      return this.joinKpi(
        this.getKpi('Appointment FU'),
        this.getKpi('5. Appointment FU'));
    },
    kpiLeadFollowUp() {
      return this.joinKpi(
        this.getKpi('Lead FU (total)'),
        this.getKpi('1. Lead FU Total'));
    },
    kpiTopComplaint() {
      return this.hasData && this.dashdata.TopComplaint ? this.dashdata.TopComplaint[0] : null;
    },
    
    clusterLMTD() {
      return this.getCluster('Legendary Moment: Test Drive');
    },
    clusterLMIO() {
      return this.getCluster('Legendary Moment: Integrated offer');
    },
    clusterXevReadyness() {
      return this.getCluster('xEV Readiness');
    },
    kpiBmwApp() {
      return this.getKpi('My BMW/MINI App');
    }
  }
};
</script>


<style lang="scss" scoped>
  @import "@/../scss/bmw/_variables_compareBoard.scss";
  @import "@/../scss/bmw/_variables.scss";
  $bmw-2021-bd-width: 1px;

  .bgfaded {
    background-color: $bmw-gray;
    border-left: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
    border-right: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
    border-bottom: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;

  }
  .ig {
    display: grid;
    height: $item-height;
    grid-template-areas: "hd"
                         "sh"
                         "pe"
                         "lfu"
                         "afu"
                         "."
                         "lm1"
                         "lm2"
                         "lm3"
                         "lm4"
                         "."
                         "ct";
    grid-template-rows: 5fr 5fr 10.5fr 10.5fr 10.5fr 1fr 10.5fr 10.5fr 10.5fr 10.5fr 1fr 7fr;
  }
  .hd {
    grid-area: hd;
    text-align: center;
  }
  .sh {
    grid-area: sh;
  }
  .pe {
    grid-area: pe;
  }
  .lfu {
    grid-area: lfu;
  }
  .afu {
    grid-area: afu;
  }
  .ct {
    grid-area: ct;
    background-color: $bmw-gray;
  }
  .hd, .sh {
    color: $bmw-2021-fg;
    background-color: $bmw-bg21;
  }
  .placeholder {
    grid-area: 3 / 1 / 12 / 2;
    text-align: center;
    font-size: 8pt;
    margin-top: 5rem;
  }
  .afu, .lm4, .bbtm {
    border-bottom: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .ct, .afu, .lfu, .pe, .lm1, .lm2, .lm3, .lm4 {
    border-right: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .ct, .afu, .lfu, .pe, .lm1, .lm2, .lm3, .lm4 {
    border-left: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .ct, .lm1 {
    border-top: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }

  .lm1 { grid-area: lm1; }
  .lm2 { grid-area: lm2; }
  .lm3 { grid-area: lm3; }
  .lm4 { grid-area: lm4; }
</style>
